import React, { useState } from 'react';

import { Button } from './Button';

import { cn } from '@/shared/lib/tailwind-merge';

export interface IItem {
    text: string;
    value: number | string;
}

export interface IItems {
    items: IItem[];
    value: number | string;
    handleChange: (value: number | string) => void;
    className?: string;
    disabled?: boolean;
    btnClassName?: string;
}

export const ButtonGroup: React.FC<IItems> = ({
    items,
    value,
    handleChange,
    className,
    disabled,
    btnClassName,
}) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleClick = (itemValue: number | string) => {
        if (!disabled) {
            setSelectedValue(itemValue);
            handleChange(itemValue);
        }
    };

    return (
        <div
            className={cn(
                'flex w-full border rounded-sm overflow-hidden',
                className,
                disabled && 'opacity-50 pointer-events-none',
            )}
        >
            {items.map((item, index) => (
                <div
                    key={index}
                    className={cn(
                        'relative flex-1 flex z-10',
                        index < items.length - 1 &&
                            selectedValue !== item.value &&
                            'after:absolute after:top-1/2 after:right-0 after:h-1/2 after:w-[1px] after:bg-border-opaque after:-translate-y-1/2 after:z-0',
                    )}
                >
                    <Button
                        variant={'outline'}
                        size='medium'
                        name={item.text}
                        aria-selected={selectedValue === item.value}
                        className={cn(
                            'w-full text-center bg-transparent font-normal focus:outline-none',
                            selectedValue === item.value
                                ? 'border-2 border-border-accent text-content-primary'
                                : 'border-none text-content-secondary hover:bg-accent',
                            btnClassName,
                        )}
                        onClick={() => handleClick(item.value)}
                    >
                        {item.text}
                    </Button>
                </div>
            ))}
        </div>
    );
};
